export const subscriptionColumnsConfig = {
  EMAIL: "Email ID",
  PHONE: "Phone Number",
  AMOUNT: "Amount",
  STATUS: "Status",
  PAYMENT_TYPE: "Payment Type",
  SUBSCRIPTION_TYPE: "Subscription Type",
  ACTIONS: "Actions",
  CREATED: "Created At",
};

